import { render, staticRenderFns } from "./MarkdownTable.vue?vue&type=template&id=61e75168&scoped=true"
import script from "./MarkdownTable.vue?vue&type=script&lang=ts"
export * from "./MarkdownTable.vue?vue&type=script&lang=ts"
import style0 from "./MarkdownTable.vue?vue&type=style&index=0&id=61e75168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e75168",
  null
  
)

export default component.exports